// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixLocation from 'wix-location';
import wixData from 'wix-data';
import wixWindow from 'wix-window';


$w.onReady(function () {
	  $w("#repeater4").onItemReady( ($item, itemData, index) => {
let status = itemData.status
if (status === "徵集中") {$item("#green").show()} else {$item("#red").show()}
  } );
	// Write your JavaScript here

})

export function button8_click(event) {
	wixLocation.to("https://www.swallowlife.org/librarysearch?search=" + $w("#input1").value)	
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

export function dropdown1_change(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
wixLocation.to("https://www.swallowlife.org/librarysearch?search=" + $w("#dropdown1").value)	// Add your code for this event here: 
}


export function input1_keyPress(event) {
	  if(event.key === "Enter"){
    wixLocation.to("https://www.swallowlife.org/librarysearch?search=" + $w("#input1").value)	
  }
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}